module.exports = "/_next/static/images/install-to-home-d4acd306adc6d0a02a01da0340de5bcc.png";